import React, { Fragment, useState, useEffect } from 'react'
import Modal from "../../../common/Modal";
import DatePicker from "react-datepicker";
import styles from './ExportModal.module.sass'
import OrderPackage from '../../../../models/OrderPackage'

import "react-datepicker/dist/react-datepicker.css";

const ExportModal = ({ }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [numOrderPackages, setNumOrderPackages] = useState(0);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    OrderPackage
      .where({ is_shipped_on: startDate.toLocaleDateString("en-US") })
      .all()
      .then((res) => {
        setNumOrderPackages(res.data.length);
      })
  }, [])

  useEffect(() => {
    OrderPackage
      .where({ is_shipped_on: startDate.toLocaleDateString("en-US") })
      .all()
      .then((res) => {
        setNumOrderPackages(res.data.length);
      })
  }, [startDate])

  const renderModal = () => {
    if (!isOpen) return;

    return (
      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel="Export"
        headerText="Export Shipped Items"
      >
        <div className={styles.modalBody}>
          <div className={styles.form}>
            <label className={styles.label}>Select Date</label>
            <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
          </div>
          <a
            className='btn btn-primary'
            target='_blank'
            href={`/api/v1/order_packages/export_shipped.csv?date=${startDate.toLocaleDateString("en-US")}`}>
            Export {numOrderPackages} items
          </a>
        </div>

      </Modal>
    )
  }

  return (
    <Fragment>
      {renderModal()}
      <a onClick={openModal} className="btn btn-primary">Export Shipped Items</a>
    </Fragment>
  )
}

export default ExportModal;
